/**********************************************************************************************************************/
/* FILE: display-fullmap/hafas_webapp_subscriptions_gui.js                                                            */
/**********************************************************************************************************************/
/* Subscriptions GUI */
HafasWebapp.prototype.subscriptions.GUI = function (_me) {
  // GUI-Events -------------------------------------------------------------------------------------------------------
  // Cookie Hint
  Hafas.ps.sub('/gui/renderCookieHint', Hafas.bind(_me.Controller.GUI.common.renderCookieHint, _me));
  Hafas.ps.sub('/gui/hideCookieHint', Hafas.bind(_me.Controller.GUI.common.hideCookieHint, _me));
  Hafas.ps.sub('/GUI/common/showCookieSettingsHint',Hafas.bind(_me.Controller.GUI.common.showCookieSettingsHint,_me));
  Hafas.ps.sub('/gui/showOnboardingToolTip', Hafas.bind(_me.Controller.GUI.common.showOnboardingToolTip, _me));
  Hafas.ps.sub('/GUI/showQrCodeOverlay', Hafas.bind(_me.Controller.GUI.common.showQrCodeOverlay, _me));

  Hafas.ps.sub('/GUI/common/toggle', Hafas.bind(_me.Controller.GUI.common.toggle, _me));
  // Neue Toggle-Funktion mit Aria-Attributen
  Hafas.ps.sub('/GUI/common/atomToggleContainer', Hafas.bind(_me.Controller.GUI.common.atomToggleContainer, _me));
  Hafas.ps.sub('/GUI/common/atomTogglePressed', Hafas.bind(_me.Controller.GUI.common.atomTogglePressed, _me));
  Hafas.ps.sub('/GUI/common/atomForwardClick', Hafas.bind(_me.Controller.GUI.common.atomForwardClick, _me));
  Hafas.ps.sub('/GUI/common/atomForwardKeyToClick', Hafas.bind(_me.Controller.GUI.common.atomForwardKeyToClick, _me));
  Hafas.ps.sub('/GUI/common/remove', Hafas.bind(_me.Controller.GUI.common.remove, _me));
  Hafas.ps.sub('/GUI/common/getLayoutClass', Hafas.bind(_me.Controller.GUI.common.getLayoutClass, _me));
  Hafas.ps.sub('/GUI/common/setBackJumpTarget', Hafas.bind(_me.Controller.GUI.setBackJumpTarget, _me));
  Hafas.ps.sub('/GUI/common/back', Hafas.bind(_me.Controller.GUI.goBack, _me));
  Hafas.ps.sub('/GUI/common/highlightingInput', Hafas.bind(_me.Controller.GUI.common.highLightingInput, _me));
  Hafas.ps.sub('/GUI/common/removeHighlightingFromInput', Hafas.bind(_me.Controller.GUI.common.removeHighLightingInput, _me));
  Hafas.ps.sub('/GUI/common/toggleColorScheme', Hafas.bind(_me.Controller.GUI.common.toggleColorScheme, _me));
  // Accessibility: Messages
  Hafas.ps.sub('/GUI/common/messages/toggleExcerptMessage', Hafas.bind(_me.Controller.GUI.common.messages.toggleExcerptMessage, _me));
  Hafas.ps.sub('/GUI/common/fixedElements/setHeights', Hafas.bind(_me.Controller.GUI.common.fixedElements.setHeights, _me));
  Hafas.ps.sub('/GUI/common/setApplicationHeader', Hafas.bind(_me.Controller.GUI.common.setApplicationHeader, _me));
  Hafas.ps.sub('/GUI/common/pageContentToggle', Hafas.bind(_me.Controller.GUI.common.pageContentToggle, _me));
  Hafas.ps.sub('/GUI/results/resize', Hafas.bind(_me.Controller.GUI.results.resize, _me));
  Hafas.ps.sub('/GUI/navigation/toggle', Hafas.bind(_me.Controller.GUI.navigation.toggle, _me));
  Hafas.ps.sub('/GUI/navigation/close', Hafas.bind(_me.Controller.GUI.navigation.close, _me));

  Hafas.ps.sub('/GUI/showMenuItemInTabBar', Hafas.bind(_me.Controller.GUI.common.showMenuItemInTabBar, _me));
  Hafas.ps.sub('/GUI/hideMenuItemInTabBar', Hafas.bind(_me.Controller.GUI.common.hideMenuItemInTabBar, _me));

  Hafas.ps.sub('/GUI/form/toggleVia', Hafas.bind(_me.Controller.GUI.form.toggleVia, _me));
  Hafas.ps.sub('/GUI/form/hide', Hafas.bind(_me.Controller.GUI.form.hide, _me));
  Hafas.ps.sub('/GUI/form/show', Hafas.bind(_me.Controller.GUI.form.show, _me));
  Hafas.ps.sub('/GUI/form/checkRadioButtons', Hafas.bind(_me.Controller.GUI.form.checkRadioButtons, _me));

  Hafas.ps.sub('/GUI/sq/toggleTab', Hafas.bind(_me.Controller.GUI.sq.toggleResultTab, _me));

  // Stboard Anzeige in der Toolbox
  Hafas.ps.sub('/GUI/sq/toggleMiniStboard', Hafas.bind(_me.Controller.GUI.sq.toggleMiniStboard, _me));
  Hafas.ps.sub('/GUI/sq/toggleMiniStboardFilter', Hafas.bind(_me.Controller.GUI.sq.toggleMiniStboardFilter, _me));
  Hafas.ps.sub('/GUI/sq/closeAllMiniStboard', Hafas.bind(_me.Controller.GUI.sq.closeAllMiniStboard, _me));
  Hafas.ps.sub('/GUI/sq/toggleNearStations', Hafas.bind(_me.Controller.GUI.sq.toggleNearStations, _me));

  // MiniEventBoard Anzeige in der Toolbox
  Hafas.ps.sub('/GUI/eventsearch/toggleMiniEventBoard', Hafas.bind(_me.Controller.GUI.eventsearch.toggleMiniEventBoard, _me));

  Hafas.ps.sub('/GUI/form/toggleSelectFormFields', Hafas.bind(_me.Controller.GUI.form.toggleSelectFormFields, _me));
  Hafas.ps.sub('/GUI/form/toggleSingleFormField', Hafas.bind(_me.Controller.GUI.form.toggleSingleFormField, _me));
  Hafas.ps.sub('/GUI/form/disableSelectFormFields', Hafas.bind(_me.Controller.GUI.form.disableSelectFormFields, _me));
  Hafas.ps.sub('/GUI/form/enableSelectFormFields', Hafas.bind(_me.Controller.GUI.form.enableSelectFormFields, _me));

  Hafas.ps.sub('/GUI/displayResults/media', Hafas.bind(_me.Controller.GUI.displayResults.media, _me));
  Hafas.ps.sub('/GUI/results/overview/setActive', Hafas.bind(_me.Controller.GUI.results.overview.setActive, _me));
  Hafas.ps.sub('/GUI/results/overview/removeActive', Hafas.bind(_me.Controller.GUI.results.overview.removeActive, _me));

  // DurationBar
  Hafas.ps.sub('/GUI/durationBar/recalculate', Hafas.bind(_me.Controller.GUI.durationBar.recalculate, _me));

  // FlyIn-Navigation
  Hafas.ps.sub('/GUI/FlyIn/toggle', Hafas.bind(_me.Controller.GUI.flyin.toggle, _me));
  Hafas.ps.sub('/GUI/FlyIn/hide', Hafas.bind(_me.Controller.GUI.flyin.hide, _me));
  Hafas.ps.sub('/GUI/FlyIn/show', Hafas.bind(_me.Controller.GUI.flyin.show, _me));

  Hafas.ps.sub('/GUI/results/additional/show', Hafas.bind(_me.Controller.GUI.results.additional.show, _me));
  Hafas.ps.sub('/GUI/results/additional/hide', Hafas.bind(_me.Controller.GUI.results.additional.hide, _me));
  Hafas.ps.sub('/GUI/results/additional/hideAll', Hafas.bind(_me.Controller.GUI.results.additional.hideAll, _me));

  Hafas.ps.sub('/GUI/results/all/hide', Hafas.bind(_me.Controller.GUI.results.all.hide, _me));
  Hafas.ps.sub('/GUI/results/overview/show', Hafas.bind(_me.Controller.GUI.results.overview.show, _me));
  Hafas.ps.sub('/GUI/results/overview/hide', Hafas.bind(_me.Controller.GUI.results.overview.hide, _me));
  Hafas.ps.sub('/GUI/results/details/show', Hafas.bind(_me.Controller.GUI.results.details.show, _me));
  Hafas.ps.sub('/GUI/results/details/hide', Hafas.bind(_me.Controller.GUI.results.details.hide, _me));
  Hafas.ps.sub('/GUI/results/details/footpathLineIndicator', Hafas.bind(_me.Controller.GUI.results.details.footpathLineIndicator, _me));


  Hafas.ps.sub('/GUI/results/overviewSQ/setActive', Hafas.bind(_me.Controller.GUI.results.overviewSQ.setActive, _me));
  Hafas.ps.sub('/GUI/results/overviewSQ/removeActive', Hafas.bind(_me.Controller.GUI.results.overviewSQ.removeActive, _me));
  Hafas.ps.sub('/GUI/results/overviewSQ/tabbar/toggle', Hafas.bind(_me.Controller.GUI.results.overviewSQ.tabbar.toggle, _me));
  Hafas.ps.sub('/GUI/results/overviewSQ/tabbar/hide', Hafas.bind(_me.Controller.GUI.results.overviewSQ.tabbar.hide, _me));

  Hafas.ps.sub('/GUI/results/overviewHimSearch/tabbar/toggle', Hafas.bind(_me.Controller.GUI.results.overviewHimSearch.tabbar.toggle, _me));
  Hafas.ps.sub('/GUI/results/overviewHimSearch/tabbar/hide', Hafas.bind(_me.Controller.GUI.results.overviewHimSearch.tabbar.hide, _me));

  // Cluster
  Hafas.ps.sub('/GUI/results/cluster/toggleGroup', Hafas.bind(_me.Controller.GUI.results.cluster.toggleGroup, _me));

  // Calendar export
  Hafas.ps.sub('/GUI/calendarExport/showOptions', Hafas.bind(_me.Controller.CalendarExport.showExportOptions, _me));
  Hafas.ps.sub('/GUI/calendarExport/closeOptions', Hafas.bind(_me.Controller.CalendarExport.closeExportOptions, _me));

  // Share Trip
  //Hafas.ps.sub('/GUI/shareSelect', Hafas.bind(_me.Controller.ShareTrip.showShareSelect, _me));
  Hafas.ps.sub('/GUI/shareTrip', Hafas.bind(_me.Controller.ShareTrip.showOverlay, _me));
  Hafas.ps.sub('/GUI/shareTrip/toggleFeature', Hafas.bind(_me.Controller.ShareTrip.toggleFeature,_me));
  Hafas.ps.sub('/GUI/shareTrip/switchChannel', Hafas.bind(_me.Controller.ShareTrip.switchChannel, _me));
  Hafas.ps.sub('/GUI/shareTrip/sendMail', Hafas.bind(_me.Controller.ShareTrip.sendMail, _me));
  Hafas.ps.sub('/GUI/shareTrip/sendSMS', Hafas.bind(_me.Controller.ShareTrip.sendSMS, _me));
  Hafas.ps.sub('/GUI/shareTrip/sendLink', Hafas.bind(_me.Controller.ShareTrip.sendLink, _me));
  Hafas.ps.sub('/GUI/shareTrip/createShortLink', Hafas.bind(_me.Controller.ShareTrip.createShortLink, _me));
  Hafas.ps.sub('/GUI/shareTrip/closeOverlay', Hafas.bind(_me.Controller.ShareTrip.closeOverlay, _me));
  Hafas.ps.sub('/GUI/shareTrip/copyLink', Hafas.bind(_me.Controller.ShareTrip.copyLink, _me));
  Hafas.ps.sub('/GUI/shareTrip/open', Hafas.bind(_me.Controller.ShareTrip.openShareLinkByType, _me));
  Hafas.ps.sub('/GUI/shareTrip/shareWithAPI', Hafas.bind(_me.Controller.ShareTrip.shareWithAPI, _me));

  // Share Location related events
  Hafas.ps.sub('/GUI/shareLocation/shareWithAPI', Hafas.bind(_me.Controller.ShareTrip.shareWithAPI, _me));
  Hafas.ps.sub('/GUI/shareLocation/openFromFlyout', Hafas.bind(_me.Controller.ShareTrip.showLocationShare, _me));
  Hafas.ps.sub('/GUI/shareLocation/open', Hafas.bind(_me.Controller.ShareTrip.openShareLinkByType, _me));
  Hafas.ps.sub('/GUI/shareLocation/removeTime', Hafas.bind(_me.Controller.ShareTrip.toggleLocationShareTime, _me));
  Hafas.ps.sub('/GUI/shareLocation/addTime', Hafas.bind(_me.Controller.ShareTrip.toggleLocationShareTime, _me));
  Hafas.ps.sub('/dateTimePicker/selectDateTime/ShareLocationDTP', Hafas.bind(_me.Controller.ShareTrip.selectDateTimeForLocationShare, _me));

  // Request-Events (from TP Module) -----------------------------------------------------------------------------------
  Hafas.ps.sub('/ui/requestStart/', Hafas.bind(_me.Controller.GUI.request.start, _me));
  Hafas.ps.sub('/ui/requestEnd/', Hafas.bind(_me.Controller.GUI.request.end, _me));
  Hafas.ps.sub('/ui/requestFail/', Hafas.bind(_me.Controller.GUI.request.fail, _me));

  // Herausgelöscht für Components.SegmentedControl
  // Hafas.ps.sub('/GUI/tabs/switch', Hafas.bind(_me.Controller.GUI.tabs.switch, _me));

  Hafas.ps.sub('/GUI/map/show', Hafas.bind(_me.Controller.GUI.map.show, _me));
  Hafas.ps.sub('/GUI/map/showIfMobile', Hafas.bind(_me.Controller.GUI.map.showIfMobile, _me));
  Hafas.ps.sub('/GUI/map/hide', Hafas.bind(_me.Controller.GUI.map.hide, _me));
  Hafas.ps.sub('/GUI/map/setDimension', Hafas.bind(_me.Controller.GUI.map.setDimension, _me));
  Hafas.ps.sub('/GUI/map/resetDimension', Hafas.bind(_me.Controller.GUI.map.resetDimension, _me));

  Hafas.ps.sub('/GUI/tabs/open', Hafas.bind(_me.Controller.GUI.tabs.open, _me));
  Hafas.ps.sub('/GUI/tabs/toggle', Hafas.bind(_me.Controller.GUI.tabs.toggle, _me));
  Hafas.ps.sub('/GUI/tabs/closeAll', Hafas.bind(_me.Controller.GUI.tabs.closeAll, _me));

  // Push
  Hafas.ps.sub('/GUI/openPush', Hafas.bind(_me.Controller.GUI.Push.showOptions, _me));
  Hafas.ps.sub('/GUI/Push/toggleChannel', Hafas.bind(_me.Controller.GUI.Push.toggleChannel, _me));
  Hafas.ps.sub('/GUI/Push/saveAlarm', Hafas.bind(_me.Controller.GUI.Push.saveAlarm, _me));
  Hafas.ps.sub('/GUI/Push/cancel', Hafas.bind(_me.Controller.GUI.Push.cancel, _me));

  // Fullscreen-Mode
  Hafas.ps.sub('/GUI/fullscreen/toggle', Hafas.bind(_me.Controller.GUI.fullscreen.toggle, _me));

  // Small ALerts
  Hafas.ps.sub('/GUI/smallAlert/show', Hafas.bind(_me.Controller.GUI.smallAlert.show, _me));
  Hafas.ps.sub('/GUI/smallAlert/hide', Hafas.bind(_me.Controller.GUI.smallAlert.hide, _me));

  // Add Kamin scrollbar for IE 11
  Hafas.ps.sub('/app/events/resize', Hafas.bind(_me.Controller.GUI.common.setFlexBoxScroll, _me));
  Hafas.ps.sub('/GUI/components/segCon/callback', Hafas.bind(_me.Controller.GUI.common.setFlexBoxScroll, _me));
  Hafas.ps.sub('/tariffsearch/updateTariffFilter', Hafas.bind(_me.Controller.GUI.common.setFlexBoxScroll, _me));

  // Tab Navigation Heading
  Hafas.ps.sub('/GUI/tabNavigationHeading/render', Hafas.bind(function() {
    _me.Controller.GUI.common.renderTabNavigationHeading();
    // Context-Menü initialisieren
    var activeFeatureContext = Hafas.getWebAppContext();
    var contextMenuBtn = Hafas('#' + activeFeatureContext + '_ActionbarMoreBtn');

    var moreOptionMenu =  Hafas.Util.gui._resolveMoreOptionMenu(activeFeatureContext,"index");
    if( moreOptionMenu !== null && contextMenuBtn!== null){
      Hafas('.hfs_actionbarMenuBtn', true).forEach(function (elem) {
        Hafas.Core.newType('HafasContextMenu', moreOptionMenu).addTo(elem);
      });
    }
  }, _me));
  Hafas.ps.sub('/GUI/tabNavigationHeading/hide', Hafas.bind(_me.Controller.GUI.common.hideNavigationHeading, _me));
  Hafas.ps.sub('/GUI/tabNavigationHeading/show', Hafas.bind(_me.Controller.GUI.common.showNavigationHeading, _me));
  Hafas.ps.sub('/GUI/leaveContext/', Hafas.bind(function () {
    Hafas.ps.pub('/GUI/tabNavigationHeading/hide');
  }, _me));

  Hafas.ps.sub('/GUI/form/clearInput', Hafas.bind(function () {
    Hafas.ps.pub('/' + Hafas.getWebAppContext().toLowerCase() + '/clearInput', []);
  }, _me));

  Hafas.ps.sub('/GUI/favorites/closePopover', Hafas.bind(_me.Controller.GUI.common.closeFavoritesPopover, _me));

  Hafas.ps.sub('/GUI/onLayoutChangeToMobile', Hafas.bind(_me.Controller.GUI.common.forcedCloseOnboardingTooltip, _me));
  Hafas.ps.sub('/GUI/onLayoutChangeMobileToDesktop', Hafas.bind(_me.Controller.GUI.common.forcedCloseOnboardingTooltip, _me));
};
